<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <!-- <div *ngIf="selectedPolicy; else loading">
                    <h2>{{selectedPolicy.title}}</h2>
                    <pre class="policy-content preserve-line-breaks" [innerHtml]="selectedPolicy.content"> </pre>
                </div> -->
                <h2>Access PAIA Records</h2>

                <p>To complete your PAIA request for access to records, please use the following links:</p>

                <ol>
                    <li><a href="https://inforegulator.org.za/wp-content/uploads/2020/07/InfoRegSA-PAIA-Form02-Reg7.pdf"
                            target="_blank">PAIA Request for Access to Record Form</a></li>
                    <li><a href="https://inforegulator.org.za/wp-content/uploads/2020/07/Form-3-PAIA.pdf"
                            target="_blank">Outcome of Request and Fees Payable</a></li>
                    <li><a href="https://inforegulator.org.za/wp-content/uploads/2020/07/InfoRegSA-PAIA-Form04-Reg9.pdf"
                            target="_blank">Internal Appeal Form</a></li>
                </ol>

                <p>For any assistance or further information, please contact us.</p>
            </mat-card-content>
            <mat-card-actions class="actions">
                <button mat-raised-button type="button" (click)="location.back()" color="primary">
                    Go Back
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>

<ng-template #loading>
    <div class="loader">
        <mat-spinner></mat-spinner>
        <p>Loading details...</p>
    </div>
</ng-template>